import coralUrl from '@/assets/avatars/avatar-coral.svg'
import mintUrl from '@/assets/avatars/avatar-mint.svg'
import amberUrl from '@/assets/avatars/avatar-amber.svg'
import skyUrl from '@/assets/avatars/avatar-sky.svg'
import lavenderUrl from '@/assets/avatars/avatar-lavender.svg'
import roseUrl from '@/assets/avatars/avatar-rose.svg'
import sageUrl from '@/assets/avatars/avatar-sage.svg'
import oceanUrl from '@/assets/avatars/avatar-ocean.svg'
import peachUrl from '@/assets/avatars/avatar-peach.svg'
import slateUrl from '@/assets/avatars/avatar-slate.svg'
import goldUrl from '@/assets/avatars/avatar-gold.svg'
import plumUrl from '@/assets/avatars/avatar-plum.svg'

const PRESET_URLS: Record<string, string> = {
  'avatar-coral': coralUrl,
  'avatar-mint': mintUrl,
  'avatar-amber': amberUrl,
  'avatar-sky': skyUrl,
  'avatar-lavender': lavenderUrl,
  'avatar-rose': roseUrl,
  'avatar-sage': sageUrl,
  'avatar-ocean': oceanUrl,
  'avatar-peach': peachUrl,
  'avatar-slate': slateUrl,
  'avatar-gold': goldUrl,
  'avatar-plum': plumUrl,
}

const SIZE_PX = { xs: 24, sm: 32, md: 40, lg: 64 } as const

interface Props {
  avatarPreset: string
  size?: keyof typeof SIZE_PX
  className?: string
}

export function Avatar({ avatarPreset, size = 'md', className = '' }: Props) {
  const px = SIZE_PX[size]
  const src = PRESET_URLS[avatarPreset] ?? coralUrl

  return (
    <img
      src={src}
      alt=""
      role="presentation"
      width={px}
      height={px}
      className={`rounded-full shrink-0 ${className}`}
      style={{ width: px, height: px }}
    />
  )
}
